export function removeUndefinedProps(obj) {
  for (var prop in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(prop) && obj[prop] === undefined) {
          delete obj[prop];
      }
  }
  return obj;
}